import Lottie from "lottie-web";

import TopNews from "./_news.es6";
import Banner from "./_banner.es6";

export default class Main {
    constructor() {
        this._init();
    }

    _init() {
        const news = new TopNews();
        const banner = new Banner();

        setTimeout(() => {
            this._topBgAnimation();
        }, 1000);
    }

    _topBgAnimation() {
        const logoanime = document.querySelector(".js-top_lottie");
        const path = logoanime.getAttribute("src");

        this.animationItem = Lottie.loadAnimation({
            container: logoanime, // the dom element that will contain the animation
            renderer: "svg",
            loop: false,
            autoplay: true,
            path: path, // the path to the animation json
        });

        this.animationItem.addEventListener("complete", () => {});
    }
}
